import './core'
import { Mobile, Navigation, AjaxifyGrid_CoreInit, Android, iOS } from './core'
import Header from './modules/header'
import './plugins/randomHover'
import './plugins/cardHover'
import './plugins/projectHover'
import './plugins/columnSpliter'
import './plugins/videoPlayer'
import './plugins/gridSizer'
import Scrollbar from 'smooth-scrollbar'
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll'

$(function() {
  $.mlmi = {
    header: undefined,
    scrollbar: undefined,
    mobile: new Mobile(),
    navigation: undefined,
    smooth: true,
  }

  $.mlmi.header = Header.init()

  $('.header > .header__directors .directors-menu__names').each(function() {
    $(this).columnSpliter();
  })

  var scrollbarStatus = {
    lastY: 0,
    direction: 'down',
    passed: false,
  }

  $('.app').each(function() {
    /* Smooth scrollbar */
    if (!iOS() && !Android() && $.mlmi.smooth) {
      $.mlmi.scrollbar = Scrollbar.init($('.app').get(0), {
        alwaysShowTracks: false,
        continuousScrolling: true,
        damping: .5,
        delegateTo: $('.app').get(0),
      })
      $.mlmi.scrollbar.addListener(function(e) {
        if ($('body').hasClass('single-director') && !$.mlmi.mobile.isMobile && $('.page-section:eq(1)').length) {
          if (e.offset.y >= scrollbarStatus.lastY) {
            scrollbarStatus.direction = 'down'
          } else {
            scrollbarStatus.direction = 'up'
          }
          scrollbarStatus.lastY = e.offset.y
          if (scrollbarStatus.direction == 'down' && !scrollbarStatus.passed && $('.page-section:eq(1)').offset().top - 220 <= $('.main-heading .page-title').offset().top) {
            $('.main-heading').addClass('main-heading--hidden')
            scrollbarStatus.passed = true
          } else if (scrollbarStatus.direction == 'up' && scrollbarStatus.passed && $('.page-section:eq(1)').offset().top - 220 > $('.main-heading .page-title').offset().top) {
            $('.main-heading').removeClass('main-heading--hidden')
            scrollbarStatus.passed = false
          }
        }
      })
    } else {
      $('.app').ScrollEvents().add(function(top, direction) {
        if ($('body').hasClass('single-director') && !$.mlmi.mobile.isMobile && $('.page-section:eq(1)').length) {
          if (direction == 'down' && !scrollbarStatus.passed && $('.page-section:eq(1)').offset().top - 220 <= $('.main-heading .page-title').offset().top) {
            $('.main-heading').addClass('main-heading--hidden')
            scrollbarStatus.passed = true
          } else if (direction == 'up' && scrollbarStatus.passed && $('.page-section:eq(1)').offset().top - 220 > $('.main-heading .page-title').offset().top) {
            $('.main-heading').removeClass('main-heading--hidden')
            scrollbarStatus.passed = false
          }
        }
      })
    }

    /* Page transition div */
    $('body').append('<div class="page-transition"></div>')
  })

  $(window).on('page_transition_ended', function() {
    /* After page transition */
    $('.page-transition').addClass('page-transition--no-transition')
    setTimeout(function() {
      $('.page-transition').removeClass('page-transition--no-transition')
    }, 100)
  })

  $(window).on('page_load', function(e, loadedContent) {
    /* Replace page class */
    if (loadedContent) {
      let loadedPage = $('<html>').html(loadedContent)
      $('head, body').attr('class', loadedPage.find('.app').data('view'))
      if (loadedPage.find('.main-heading').length) {
        $('.app').before(loadedPage.find('.main-heading').detach())
      }
      if (loadedPage.find('.mobile-heading').length) {
        $('main').before(loadedPage.find('.mobile-heading').detach())
      }
      if (loadedPage.find('.heading').length) {
        $('main').before(loadedPage.find('.heading').detach())
      }
      if (loadedPage.find('.header__lang-switcher').length) {
        $('.header__lang-switcher').replaceWith(loadedPage.find('.header__lang-switcher').detach())
      }
    }

    $.mlmi.mobile.add(function() {
      $('body').removeClass('--open-contact')
    }, function() {
      $('body').addClass('--open-contact')
    })

    $('.grid--style--home, .grid--style--culture, .grid--style--director').each(function() {
      $(this).GridSizer();
    })

    $('.card-home, .card-director').each(function() {
      $(this).cardHover();
    })

    $('.over-target:not(.grid__item .over-target)').each(function() {
      $(this).randomHover();
    })

    if (!iOS() && !Android()) {
      $('.project-wrapper').each(function() {
        $(this).projectHover();
      })
    }

    $('.director__interview').each(function() {
      $(this).columnSpliter(3);
    })

    $('.single-project__iframe').each(function() {
      $(this).videoPlayer();
    })

    $('.credits__show-btn').on('click', function() {
      if ($(this).attr('aria-expanded') === 'false') {
        $(this).attr('aria-expanded', 'true')
        $('.credits__list').slideDown({
          'duration': 450,
          'easing': 'easeInOutQuart',
        }).attr('aria-hidden', 'false')
      }
    })

    if ($('body').hasClass('with-intro')) {
      setTimeout(function() {
        if ($('body').hasClass('front-page')) {
          $('body').addClass('front-page--loaded')
        }
      }, 2900 - 750)
    }

    AjaxifyGrid_CoreInit([
      {
        classSelector: 'grid--style--director',
        afterUpdate: function(grid) {
          $('.grid--style--director').GridSizer().do_resize()
          $.mlmi.navigation.registerLinks()
          $('.project-wrapper').each(function() {
            $(this).projectHover();
          })
        },
      },
    ])
  })

  $(window).on('page_exit', function() {
    /* Unload images */
    $('main').find('img').attr('src', '').remove()

    /* Scroll to top */
    if ($.mlmi.scrollbar != undefined) {
      $.mlmi.scrollbar.setPosition(0, 0)
    } else {
      $('.app').scrollTop(0)
    }

    /* Remove specific elements */
    $('.heading, .main-heading, .mobile-heading').remove()

    /* Unload dynamic styles */
    $('.dynamic-styles, .loader_image').remove()

    /* Hide menus immediately */
    $('.header__main, .header__directors').hide()
    requestAnimationFrame(function() {
      $('body').removeClass('--menu-open')
      $('.menu-panel').css('display', 'none')
      requestAnimationFrame(function() {
        $('.header__main, .header__directors').css('display', '')
        $('.burger').css('display', '')
      })
    })

    /* Close burger */
    $('.burger').hide().attr('aria-expanded', 'false');
    $('body').removeClass('--menu-open --no-scroll --open-directors-desktop --open-directors-mobile')
    $('.header__burger-wrapper').removeClass('--white')
  })

  /* Navigation */
  if ($('body').hasClass('with-transitions')) {
    $.mlmi.navigation = new Navigation({
      selectors: {
        pageContent: 'main',
        pageTarget: 'main',
      },
      on: {
        beforeRegisterLinks: function() {
          $('.language-switcher a').data('preventTransition', 1)
        },
      }
    })
  } else {
    $(window).trigger('page_load')
  }
})
